import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { SplitButton, MenuItem } from 'react-bootstrap/lib';
import { Confirm } from 'react-confirm-bootstrap';
import LoginVerificationMessage from '../LoginVerificationMessage';
import ErrorMessage from '../ErrorMessage';
import './LoginList.scss';

class LoginList extends PureComponent {
  componentWillUnmount() {
    this.props.resetLoginVerification();
  }

  actionFormatter = (cell, row) => (
    <div>
      <SplitButton
        title="Edit"
        key={row.id}
        id={`split-button-basic-${row.id}`}
        onClick={() => {
          this.props.history.push(
            `/${row.dealer_id}/crmLogins/crmLogin/${row.id}`,
          );
        }}
      >
        <MenuItem
          title="Test CRM Login"
          onClick={() =>
            this.props.verifyLogin({ login: row, loginId: row.id })
          }
        >
          Test
        </MenuItem>
        <Confirm
          onConfirm={() => this.props.onDelete(row.id)}
          body={`Are you sure you want to delete ${row.login}?`}
          confirmText="Confirm Delete"
          title={`Deleting ${row.login}`}
        >
          <MenuItem>Delete</MenuItem>
        </Confirm>
      </SplitButton>
    </div>
  );

  createCustomInsertButton = (dealerId) => (
    <Link
      className="btn btn-primary btn-large new-btn-space"
      to={{ pathname: `/${dealerId}/crmLogins/crmlogin/` }}
    >
      Add New
    </Link>
  );

  render() {
    const { list, error, dealer, verificationStatus } = this.props;

    const options = {
      insertBtn: () => this.createCustomInsertButton(dealer.id),
    };

    return (
      <div className="login-list-container">
        {error && <ErrorMessage error={error} />}
        <LoginVerificationMessage verificationStatus={verificationStatus} />
        <BootstrapTable
          data={list}
          options={options}
          insertRow
          striped
          hover
          pagination
          bodyContainerClass="list-body-container"
          tableStyle={{ border: 'none' }}
        >
          <TableHeaderColumn isKey dataField="login" dataSort>
            Login
          </TableHeaderColumn>
          <TableHeaderColumn dataField="type">Type</TableHeaderColumn>
          <TableHeaderColumn
            dataField="button"
            columnClassName="list-action-column"
            dataFormat={this.actionFormatter}
          />
        </BootstrapTable>
      </div>
    );
  }
}

LoginList.propTypes = {
  error: PropTypes.any,
  list: PropTypes.array,
  history: PropTypes.object,
  dealer: PropTypes.object,
  onDelete: PropTypes.func,
  verificationStatus: PropTypes.object,
  verifyLogin: PropTypes.func,
  resetLoginVerification: PropTypes.func,
};

export default withRouter(LoginList);
